import { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import { adminApi } from "../../lib/api";

export const WhatsAppAlerts = () => {
  const [info, setInfo] = useState(null);
  useEffect(() => {
    adminApi.get("/employer/matches/whatsapp").then((r) => setInfo(r.data)).catch(() => {});
  }, []);
  if (!info?.enabled) return null;
  const link = info.sandbox_join ? `https://wa.me/${info.number.replace(/\D/g, "")}?text=${encodeURIComponent(info.sandbox_join)}` : null;
  return (
    <div data-testid="whatsapp-alerts-card" className="flex flex-wrap items-center justify-between gap-4 border border-emerald-500/30 bg-emerald-500/5 px-5 py-4">
      <p className="flex items-center gap-3 text-sm text-slate-300">
        <MessageCircle className="h-5 w-5 shrink-0 text-emerald-400" />
        <span>Top Match (80%+) alerts come to your HR number on WhatsApp.
          {info.sandbox_join && <> To start receiving them, send <span data-testid="whatsapp-join-code" className="font-mono text-emerald-300">{info.sandbox_join}</span> to {info.number} once.</>}
        </span>
      </p>
      {link && (
        <a href={link} target="_blank" rel="noreferrer" data-testid="whatsapp-join-link"
          className="bg-emerald-600 px-4 py-2 text-sm font-semibold text-white hover:bg-emerald-500">Activate on WhatsApp</a>
      )}
    </div>
  );
};
